/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiAlertDecisionRuleCommand } from './InternalApiAlertDecisionRuleCommand';
import {
    InternalApiAlertDecisionRuleCommandFromJSON,
    InternalApiAlertDecisionRuleCommandFromJSONTyped,
    InternalApiAlertDecisionRuleCommandToJSON,
    InternalApiAlertDecisionRuleCommandToJSONTyped,
} from './InternalApiAlertDecisionRuleCommand';

/**
 * a base for representing decision rules
 * @export
 * @interface InternalApiAlertDecisionRule
 */
export interface InternalApiAlertDecisionRule {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertDecisionRule
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertDecisionRule
     */
    sortOrder: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertDecisionRule
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiAlertDecisionRule
     */
    runOnlyOnFinal: boolean;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiAlertDecisionRule
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {InternalApiAlertDecisionRuleCommand}
     * @memberof InternalApiAlertDecisionRule
     */
    runCommand: InternalApiAlertDecisionRuleCommand;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiAlertDecisionRule
     */
    values: Array<string>;
}



/**
 * Check if a given object implements the InternalApiAlertDecisionRule interface.
 */
export function instanceOfInternalApiAlertDecisionRule(value: object): value is InternalApiAlertDecisionRule {
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('runOnlyOnFinal' in value) || value['runOnlyOnFinal'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('runCommand' in value) || value['runCommand'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function InternalApiAlertDecisionRuleFromJSON(json: any): InternalApiAlertDecisionRule {
    return InternalApiAlertDecisionRuleFromJSONTyped(json, false);
}

export function InternalApiAlertDecisionRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertDecisionRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sortOrder': json['sortOrder'],
        'name': json['name'],
        'runOnlyOnFinal': json['runOnlyOnFinal'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'runCommand': InternalApiAlertDecisionRuleCommandFromJSON(json['runCommand']),
        'values': json['values'],
    };
}

export function InternalApiAlertDecisionRuleToJSON(json: any): InternalApiAlertDecisionRule {
    return InternalApiAlertDecisionRuleToJSONTyped(json, false);
}

export function InternalApiAlertDecisionRuleToJSONTyped(value?: InternalApiAlertDecisionRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sortOrder': value['sortOrder'],
        'name': value['name'],
        'runOnlyOnFinal': value['runOnlyOnFinal'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'runCommand': InternalApiAlertDecisionRuleCommandToJSON(value['runCommand']),
        'values': value['values'],
    };
}

